import Layout from '../../components/base/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Problemas() {
  const { t } = useTranslation();
  
  return (
    <Layout>
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            {t('prob_title')}
          </h1>
        </div>

        {/* Pakket vastgelopen */}
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-3xl font-semibold mb-6 text-red-600">{t('prob_jammed')}</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <div className="bg-red-50 p-6 rounded-lg mb-6">
                <h3 className="text-xl font-semibold mb-3 text-red-800">{t('prob_jammed_cause')}</h3>
              </div>

              <div className="bg-green-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold mb-3 text-green-800">{t('prob_jammed_solution')}</h3>
                <ol className="space-y-3">
                  {[
                    t('prob_jammed_sol1'),
                    t('prob_jammed_sol2'),
                    t('prob_jammed_sol3'),
                    t('prob_jammed_sol4')
                  ].map((sol, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <div className="w-6 h-6 flex items-center justify-center bg-green-600 text-white rounded-full text-sm font-bold">
                        {index + 1}
                      </div>
                      <span>{sol}</span>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/cc91c1669c4ebd9380f18d0156aa91e6.jpg"
                alt={t('prob_jammed')}
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>

        {/* Sensorstoring */}
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-3xl font-semibold mb-6 text-orange-600">{t('prob_sensor')}</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <div className="bg-orange-50 p-6 rounded-lg mb-6">
                <h3 className="text-xl font-semibold mb-3 text-orange-800">{t('prob_sensor_cause')}</h3>
              </div>

              <div className="bg-blue-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold mb-3 text-blue-800">{t('prob_sensor_solution')}</h3>
                <ol className="space-y-3">
                  {[
                    t('prob_sensor_sol1'),
                    t('prob_sensor_sol2'),
                    t('prob_sensor_sol3'),
                    t('prob_sensor_sol4')
                  ].map((sol, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <div className="w-6 h-6 flex items-center justify-center bg-blue-600 text-white rounded-full text-sm font-bold">
                        {index + 1}
                      </div>
                      <span>{sol}</span>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Industrial%20sensor%20maintenance%2C%20technician%20cleaning%20photoelectric%20sensor%2C%20conveyor%20belt%20sensor%20inspection%2C%20industrial%20automation%20maintenance%2C%20professional%20sensor%20servicing&width=500&height=400&seq=problem2&orientation=landscape"
                alt={t('prob_sensor')}
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>

        {/* Mechanische storing */}
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-3xl font-semibold mb-6 text-purple-600">{t('prob_mechanical')}</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">{t('prob_mech_examples')}</h3>
              <div className="space-y-4">
                {[
                  { problem: t('prob_mech_ex1'), solution: t('prob_mech_sol1') },
                  { problem: t('prob_mech_ex2'), solution: t('prob_mech_sol2') },
                  { problem: t('prob_mech_ex3'), solution: t('prob_mech_sol3') }
                ].map((item, index) => (
                  <div key={index} className="bg-purple-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-purple-800">{item.problem}</h4>
                    <p className="text-sm text-gray-600 mt-1">{item.solution}</p>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Conveyor%20belt%20mechanical%20maintenance%2C%20industrial%20technician%20adjusting%20belt%20tension%2C%20mechanical%20repair%20work%2C%20industrial%20maintenance%20scene%2C%20professional%20equipment%20servicing&width=500&height=400&seq=problem3&orientation=landscape"
                alt={t('prob_mechanical')}
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>

        {/* Elektrische storing */}
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-3xl font-semibold mb-6 text-blue-600">{t('prob_electrical')}</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <div className="bg-blue-50 p-6 rounded-lg mb-6">
                <h3 className="text-xl font-semibold mb-3 text-blue-800">{t('prob_elec_examples')}</h3>
                <ul className="space-y-2">
                  {[
                    t('prob_elec_ex1'),
                    t('prob_elec_ex2'),
                    t('prob_elec_ex3'),
                    t('prob_elec_ex4')
                  ].map((ex, index) => (
                    <li key={index} className="flex items-start space-x-2">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-flashlight-line text-blue-600"></i>
                      </div>
                      <span>{ex}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-yellow-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold mb-3 text-yellow-800">{t('prob_elec_solution')}</h3>
                <ol className="space-y-3">
                  {[
                    t('prob_elec_sol1'),
                    t('prob_elec_sol2'),
                    t('prob_elec_sol3')
                  ].map((sol, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <div className="w-6 h-6 flex items-center justify-center bg-yellow-600 text-white rounded-full text-sm font-bold">
                        {index + 1}
                      </div>
                      <span>{sol}</span>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Electrical%20maintenance%20on%20industrial%20conveyor%20system%2C%20technician%20checking%20electrical%20connections%2C%20multimeter%20testing%2C%20industrial%20electrical%20work%2C%20professional%20electrical%20troubleshooting&width=500&height=400&seq=problem4&orientation=landscape"
                alt={t('prob_electrical')}
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>

        {/* PLC storing */}
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-3xl font-semibold mb-6 text-green-600">{t('prob_plc')}</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <div className="bg-green-50 p-6 rounded-lg mb-6">
                <h3 className="text-xl font-semibold mb-3 text-green-800">{t('prob_plc_examples')}</h3>
                <ul className="space-y-2">
                  {[
                    t('prob_plc_ex1'),
                    t('prob_plc_ex2'),
                    t('prob_plc_ex3')
                  ].map((ex, index) => (
                    <li key={index} className="flex items-start space-x-2">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-error-warning-line text-green-600"></i>
                      </div>
                      <span>{ex}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-red-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold mb-3 text-red-800">{t('prob_plc_solution')}</h3>
                <ol className="space-y-3">
                  {[
                    t('prob_plc_sol1'),
                    t('prob_plc_sol2'),
                    t('prob_plc_sol3'),
                    t('prob_plc_sol4')
                  ].map((sol, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <div className="w-6 h-6 flex items-center justify-center bg-red-600 text-white rounded-full text-sm font-bold">
                        {index + 1}
                      </div>
                      <span>{sol}</span>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=PLC%20control%20panel%20with%20error%20codes%2C%20industrial%20automation%20troubleshooting%2C%20technician%20reading%20PLC%20display%2C%20control%20system%20diagnostics%2C%20professional%20industrial%20maintenance&width=500&height=400&seq=problem5&orientation=landscape"
                alt={t('prob_plc')}
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>

        <div className="flex justify-between items-center">
          <Link 
            to="/funcionamento"
            className="flex items-center text-blue-600 hover:text-blue-700 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-arrow-left-line"></i>
            </div>
            {t('nav_operation')}
          </Link>
          <Link 
            to="/diagnostico"
            className="flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('nav_diagnosis')}
            <div className="w-5 h-5 flex items-center justify-center ml-2">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </Layout>
  );
}
